export default {
  booking_channels: []
}
